export default function ComparisonTable() {
  const rows = [
    { method: 'Losowe wyszukiwanie', time: 'Długi', risk: 'Wysokie', comfort: 2 },
    { method: 'Samodzielne porównywanie', time: 'Średni', risk: 'Średnie', comfort: 3 },
    { method: 'Kakobuy Spreadsheet', time: 'Krótki', risk: 'Niskie', comfort: 5, highlight: true },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Dlaczego warto korzystać z Kakobuy Spreadsheet?
          </h2>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200/80 bg-background-50">
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/80 bg-background-100/70">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Metoda</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Czas wyszukiwania</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Ryzyko błędu</th>
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-700">Wygoda</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr
                  key={idx}
                  className={`border-b border-background-200/50 last:border-b-0 ${
                    row.highlight ? 'bg-primary-50/60' : ''
                  }`}
                >
                  <td className="px-6 py-4">
                    <span className={`text-sm font-medium ${row.highlight ? 'text-primary-800' : 'text-foreground-800'}`}>
                      {row.highlight && (
                        <span className="inline-block w-2 h-2 bg-accent-500 rounded-full mr-2 align-middle"></span>
                      )}
                      {row.method}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      row.time === 'Krótki' ? 'bg-accent-100 text-accent-800' :
                      row.time === 'Średni' ? 'bg-secondary-100 text-secondary-800' :
                      'bg-foreground-100 text-foreground-600'
                    }`}>
                      {row.time}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      row.risk === 'Niskie' ? 'bg-primary-100 text-primary-800' :
                      row.risk === 'Średnie' ? 'bg-secondary-100 text-secondary-800' :
                      'bg-accent-100 text-accent-800'
                    }`}>
                      {row.risk}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i
                            className={`text-sm ${
                              i < row.comfort
                                ? 'ri-star-fill text-amber-400'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          ></i>
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}